// @flow

import styled from '@emotion/styled'
import * as React from 'react'

type ClientRenderProps = {
  hideServerRender?: boolean,
  children: React.Node,
}

/**
 * Component that renders the children in the browser and on the server.
 * Avoids SSR issues by re-rendering on the client with a new key,
 * preventing bad rehydration.
 * Wrap dynamic components in this component to avoid SSR issues.
 * ie. If your component depends non-static content based on search params.
 */
export function ClientRender({
  hideServerRender = false,
  children,
}: ClientRenderProps) {
  const [renderKey, setRenderKey] = React.useState('server')
  React.useLayoutEffect(() => setRenderKey('client'), [])
  return (
    <Root key={renderKey} hide={hideServerRender && renderKey === 'server'}>
      {children}
    </Root>
  )
}

type Props = {|
  hide: boolean,
  children: React.Node,
|}

const Root = (styled.div`
  visibility: ${({ hide }) => (hide ? 'hidden' : 'visible')};
`: React.StatelessFunctionalComponent<Props>)
